import React, { useContext, Fragment } from 'react';
import { SurveyContext } from '../context/surveyContext';

export default function ResultList({ exportPdf }) {
  const { survey } = useContext(SurveyContext);

  return (
    <Fragment>
      {survey && (
        <section className='result__result-section print'>
          <div className='result__result-section-text'>
            <h2>{survey.title_result}</h2>
            <p>{survey.description_result}</p>
          </div>
          <div className='result__result-section-information'>
            <div>
              <span className='resultIndicator green'></span>
              <p>= Mindre behov</p>
            </div>
            <div>
              <span className='resultIndicator yellow'></span>
              <p>= Ganska stort behov</p>
            </div>
            <div>
              <span className='resultIndicator red'></span>
              <p>= Stort behov</p>
            </div>
          </div>
          <div className='result__result-section-list'>
            {survey.highScoreList && survey.highScoreList.length > 0 && (
              <section>
                <h5>Kompetens finns</h5>
                <ul>
                  {survey.highScoreList.map((result) => (
                    <li>
                      <span className='resultIndicator green'></span>
                      <a href={result.url.url} target='_blank' rel='noreferrer'>
                        <div div className='result-list-text'>
                          <p>{result.title}</p>
                          <p>{result.description}</p>
                        </div>
                        <svg
                          className='arrow bounce-animation'
                          xmlns='http://www.w3.org/2000/svg'
                          width='16'
                          height='16'
                          viewBox='0 0 16 16'
                        >
                          <polygon
                            class='poly'
                            fill-rule='evenodd'
                            points='3.8 7 9.4 1.4 8 0 0 8 8 16 9.4 14.6 3.8 9 16 9 16 7'
                            transform='matrix(-1 0 0 1 16 0)'
                          />
                        </svg>
                      </a>
                    </li>
                  ))}
                </ul>
              </section>
            )}
            {survey.lowScoreList && survey.lowScoreList.length > 0 && (
              <section>
                <h5>Kompetens saknas helt eller delvis</h5>
                <ul>
                  {survey.lowScoreList.map((result) => (
                    <li>
                      <span
                        className={`resultIndicator ${
                          result.percent > 0.33 ? 'yellow' : 'red'
                        }`}
                      ></span>
                      <a href={result.url.url} target='_blank' rel='noreferrer'>
                        <div className='result-list-text'>
                          <p>{result.title}</p>
                          <p>{result.description}</p>
                        </div>
                        <svg
                          className='arrow bounce-animation'
                          xmlns='http://www.w3.org/2000/svg'
                          width='16'
                          height='16'
                          viewBox='0 0 16 16'
                        >
                          <polygon
                            class='poly'
                            fill-rule='evenodd'
                            points='3.8 7 9.4 1.4 8 0 0 8 8 16 9.4 14.6 3.8 9 16 9 16 7'
                            transform='matrix(-1 0 0 1 16 0)'
                          />
                        </svg>
                      </a>
                    </li>
                  ))}
                </ul>
              </section>
            )}
          </div>
          {/* <div className='icon-wrapper'>
            <div className='icons' onClick={exportPdf}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 18 18'
              >
                <path
                  fill='#131313'
                  d='M19,12 L19,19 L5,19 L5,12 L3,12 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,12 L19,12 Z M13,12.67 L15.59,10.09 L17,11.5 L12,16.5 L7,11.5 L8.41,10.09 L11,12.67 L11,3 L13,3 L13,12.67 Z'
                  transform='translate(-3 -3)'
                />
              </svg>
            </div>
            <div className='icons' onClick={() => window.print()}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='18'
                viewBox='0 0 20 18'
              >
                <path
                  fill='#131313'
                  d='M19,9 L5,9 C3.34,9 2,10.34 2,12 L2,18 L6,18 L6,22 L18,22 L18,18 L22,18 L22,12 C22,10.34 20.66,9 19,9 Z M16,20 L8,20 L8,15 L16,15 L16,20 Z M19,13 C18.45,13 18,12.55 18,12 C18,11.45 18.45,11 19,11 C19.55,11 20,11.45 20,12 C20,12.55 19.55,13 19,13 Z M18,4 L6,4 L6,8 L18,8 L18,4 Z'
                  transform='translate(-2 -4)'
                />
              </svg>
            </div>
          </div> */}
        </section>
      )}
    </Fragment>
  );
}
